<template>
  <div class="flex-inner-right">

    <!-- 验证码登录和密码登录 -->
    <template v-if="showCode === 0">
      <!--      <img @click="sendCode" class="flex-inner-right-img" src="../../static/index/code-little.png" alt=""/>-->
      <div class="flex-inner-right-box">
        <div class="flex-inner-right-box-title">化联网</div>
        <div class="menu-box hit-cursor">
          <div @click="activeIndex = 1" :class="activeIndex === 1 ? 'menu-item-active' : 'menu-item'">
            密码登录
          </div>
          <div @click="activeIndex = 2" :class="activeIndex === 2 ? 'menu-item-active' : 'menu-item'">
            验证码登录
          </div>
          <div @click="selectFun" :class="activeIndex === 3 ? 'menu-item-active' : 'menu-item'">
            微信登录
          </div>
        </div>
        <!-- 密码登录 -->
        <template v-if="activeIndex === 1">
          <div class="input-box">
            <el-form :model="user" :rules="loginRules" ref="userForm">
              <el-form-item prop="name">
                <el-input placeholder="请输入账号" v-model="user.name">
                  <i slot="prefix">
                    <img class="input-icon" src="../../static/login/user.png" alt="" /></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="passWord">
                <el-input placeholder="请输入密码" v-model="user.passWord" type="password" show-password>
                  <i slot="prefix">
                    <img class="input-icon" src="../../static/login/pas.png" alt="" /></i>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="login-box">
            <el-button class="btn-size" type="primary" @click="goLogin">登录</el-button>
            <div class="login-box-text">
              还没有账号？
              <span class="color-blue hit-cursor" @click="goRegister">立即注册</span>
              <span class="color-blue hit-cursor margin-10" @click="goWarry">忘记密码</span>
              <span class="color-blue hit-cursor margin-10" @click="rebackHome" v-if="showHome">返回首页</span>
            </div>

          </div>
        </template>
        <!-- 验证码登录 -->
        <template v-if="activeIndex === 2">
          <div class="input-box">
            <el-form :model="userCode" :rules="loginRulesCode" ref="userCodeForm">
              <el-form-item prop="mobile">
                <el-input placeholder="请输入手机号码" v-model="userCode.mobile">
                  <i slot="prefix">
                    <img class="input-icon" src="../../static/login/user.png" alt="" /></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-row>
                  <el-col :span="14">
                    <el-input placeholder="请输入验证码" v-model="userCode.code">
                      <i slot="prefix">
                        <img class="input-icon" src="../../static/login/code.png" alt="" /></i>
                    </el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <div class="btn-code" v-if="time == 0" @click="getCode">
                      获取验证码
                    </div>
                    <div class="btn-code" v-else>{{ time }}秒后获取</div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
          <div class="login-box">
            <el-button class="btn-size" type="primary" @click="goCodeLogin">登录</el-button>
            <div class="login-box-text">
              还没有账号？
              <span class="color-blue hit-cursor" @click="goRegister">立即注册</span>
            </div>
          </div>
        </template>
        <!-- <template v-if="activeIndex === 3">
          <img :src="qrcode_url" alt="微信登录二维码" class="qrcode-img">
          <div class="login-box">
            <div class="login-box-text">
              还没有账号？
              <span class="color-blue" @click="goRegister">立即注册</span>
            </div>
          </div>
        </template> -->
      </div>
    </template>
    <template v-if="showCode === 2">
      <div class="user-dashboard">
        <!-- 用户欢迎区域 -->
        <div class="welcome-section">
          <div class="user-avatar">
            <img :src="userInfo.avatar" alt="">
          </div>
          <div class="user-info">
            <div class="welcome-text">
              欢迎回来，<span class="user-name" v-if="userInfo.mobile">{{
                $utils.maskPhoneNumber(userInfo.mobile)
              }}</span>
              <span class="user-name" v-else>{{ userInfo.nickname }}</span>
            </div>
            <div class="user-status">
              <el-tag v-if="userInfo.vip_status == 1" type="warning" size="small">{{ userInfo.member_type == 1 ? 'VIP' :
                'SVIP' }}会员
              </el-tag>
              <el-tag v-else type="info" size="small">普通用户</el-tag>
            </div>
          </div>
        </div>

        <!-- 快捷操作区域 -->
        <div class="quick-actions" v-loading="!user_count">
          <div class="action-grid">
            <div class="action-card" @click="goProduct">
              <div class="action-icon">
                <i class="el-icon-plus"></i>
              </div>
              <div class="action-text">发布产品（{{ user_count.product_count || 0 }}）</div>
            </div>

            <div class="action-card" @click="goBuyProduct">
              <div class="action-icon">
                <i class="el-icon-shopping-bag-1"></i>
              </div>
              <div class="action-text">
                发布询单（{{ user_count.quote_count || 0 }}<span v-if="user_count.quote_success_count">/{{
                  user_count.quote_success_count }}</span>）
              </div>
            </div>

            <div class="action-card" @click="goOrderManagement">
              <div class="action-icon">
                <i class="el-icon-s-order"></i>
              </div>
              <div class="action-text">订单管理({{ user_count.order_count || 0 }})</div>
            </div>

            <div class="action-card" @click="goMessage">
              <div class="action-icon">
                <i class="el-icon-chat-dot-round"></i>
              </div>
              <div class="action-text">消息中心({{ user_count.message_count || 0 }})</div>
            </div>
          </div>
        </div>

        <!-- 底部操作按钮 -->
        <div class="dashboard-footer">
          <el-button type="primary" class="primary-btn" @click="goUserCenter">
            <i class="el-icon-user"></i>
            个人中心
          </el-button>
          <el-button type="text" class="logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i>
            退出登录
          </el-button>
        </div>

      </div>
    </template>
  </div>
</template>
<script>
import { login, loginForCode, sendSmsCode } from "@/api/modules/user";
import { login_pc_qrcode, callback } from "../../api";
import config from "../../config/config";

export default {
  name: "login-box",
  props: {
    showHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showInquiry: false,
      user: {
        name: "",
        passWord: "",
      },
      userCode: {
        mobile: "",
        code: "",
      },
      loginRules: {
        name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loginRulesCode: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 6, message: "验证码长度应为4-6位", trigger: "blur" },
        ],
      },
      activeIndex: 1,
      time: 0,
      // 扫码登录
      showCode: 0,
      qrcode_url: '',
      wechatDialogVisible: false, // 微信登录弹窗控制
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    user_count() {
      // 添加安全检查
      const count = this.$store.getters.user_count;
      return count && typeof count === 'object' ? count : {};
    },
  },
  watch: {
    '$store.getters.user_count': {
      handler(newVal, oldVal) {
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    },
    isLogin: {
      handler(val) {
        if (val) {
          this.$store.dispatch('GET_USER_COUNT');
          this.showCode = 2;
        } else {
          this.showCode = 0;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    rebackHome() {
      this.$router.push('/')
    },
    changeOrder(e) {
      this.showInquiry = e
    },
    // 安全导航：避免对当前路由的重复跳转，并忽略重复导航错误
    safeNavigate(path, { replace = false } = {}) {
      if (!path) return;
      if (this.$route && this.$route.path === path) {
        return;
      }
      const nav = replace ? this.$router.replace(path) : this.$router.push(path);
      return nav && nav.catch && nav.catch(err => {
        if (err && err.name === 'NavigationDuplicated') {
          return;
        }
        throw err;
      });
    },
    // 忘记密码
    goWarry() {
      this.$router.push("/agreement/findPassword");
    },
    // 校验手机号码格式的方法
    validateMobile(mobile) {
      const mobilePattern = /^1[3-9]\d{9}$/;
      return mobilePattern.test(mobile);
    },
    selectFun() {
      // this.activeIndex = 3
      // console.log('zhixinge');

      login_pc_qrcode().then(res => {
        if (res.data.code == 10000) {
          this.qrcode_url = res.data.data.qrcode_url
          this.wechatDialogVisible = true; // 显示弹窗
          this.openWindow()

        }
      })

    },
    openWindow() {
      // 确保qrcode_url已经获取到
      if (!this.qrcode_url) {
        console.error('二维码URL未获取到')
        return
      }
      const width = 400;
      const height = 500;
      const left = (screen.width - width) / 3;
      const top = (screen.height - height) / 3;
      const loginWindow = window.open(
        this.qrcode_url, // 确保这个路由指向你的登录页面
        'LoginWindow',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );
      console.log('loginWindow-----------------------------------------', this.qrcode_url)
      // 检查弹窗是否被浏览器阻止
      if (!loginWindow) {
        this.$message.error('弹窗被浏览器阻止，请允许弹窗后重试')
        return
      }
      // 定义消息处理函数
      const handleMessage = (event) => {
        // 允许所有来源的消息用于调试（生产环境应限制具体域名）
        // const allowedOrigin = event.origin;
        // console.log('allowedOrigin', allowedOrigin)
        // if (event.origin !== allowedOrigin) {
        //   console.log('来源不匹配，拒绝消息');
        //   return;
        // }

        if (event.data.type === 'WECHAT_LOGIN_REDIRECT') {
          const { data } = event.data;
          // 收到消息后移除事件监听器
          window.removeEventListener('message', handleMessage);
          // 关闭弹窗
          if (loginWindow && !loginWindow.closed) {
            loginWindow.close();
          }
          callback(data).then(res => {
            if (res.data.code === 10000) {
              let data = res.data.data;
              this.setInfo(data)
              this.$message.success('微信登录成功！');
            } else {
              this.$message.error(res.data.message || '登录失败');
            }
          }).catch(error => {
            console.error('登录请求失败:', error);
            this.$message.error('登录请求失败');
          })
        } else {
          console.log('其他消息:--------------------------------------------', event);
        }
      };

      // 绑定 message 事件
      window.addEventListener('message', handleMessage);
      // 监听弹窗是否关闭
      const checkPopup = setInterval(() => {
        console.log('loginWindow.closed', loginWindow.closed)
        if (loginWindow.closed) {
          clearInterval(checkPopup);
          // 清理消息监听器
          window.removeEventListener('message', handleMessage);
          console.log('登录窗口已关闭');
        }
      }, 500);
    },

    // 跳转到留言
    goMessage() {
      this.$router.push("/user/message/mail");
    },
    // 发布产品
    goProduct() {
      if (this.mixCheckUserAudit()) {
        this.$router.push("/user/supplier/my-project");
      }
    },
    // 发布求购
    goBuyProduct() {
      // this.showInquiry=true
      if (this.mixCheckUserAudit()) {
        this.$emit('changeOrder', true)
      }
      // this.$router.push("/user/purchase/post");
    },
    // 跳转到用户中心
    goUserCenter() {
      this.$router.push("/user/index");
    },
    // 跳转到订单管理
    goOrderManagement() {
      this.$router.push("/user/purchase/order");
    },
    // 退出登录
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 清除用户信息
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_TOKEN", "");
        this.$store.commit("SET_USERINFO", {});
        this.$utils.removeCookie("token");
        this.showCode = 0;
        this.$message.success("退出登录成功！");
        this.safeNavigate("/", { replace: false });
      }).catch(() => {
        // 用户取消退出
      });
    },
    // 获取token
    getToken() {
      let token = this.$utils.getCookie("token");
      if (!this.$utils.isEmpty(token)) {
        this.showCode = 2;
      } else {
        this.showCode = 0;
      }
    },
    // 展示扫码
    sendCode() {
      this.showCode = 1;
    },
    // 密码登录
    goCodePage() {
      this.showCode = 0;
    },
    // 立即注册
    goRegister() {
      this.$router.push("/register");
    },
    // 获取验证码
    getCode() {
      if (!this.userCode.mobile) {
        this.$message({
          type: 'error',
          message: `请输入手机号！`
        });
        return
      }
      // 校验手机号格式是否正确
      if (!this.validateMobile(this.userCode.mobile)) {
        this.$message({
          type: 'error',
          message: `请输入正确的手机号码！`,
          offset: 300
        });
        return
      }

      this.time = 59;
      let timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      sendSmsCode({ mobile: this.userCode.mobile, type: '2' }).then(res => {
        if (res.data.code != 10000) {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else {
          this.$message.success("验证码已发送");
        }
      })
    },
    // 验证码登录
    goCodeLogin() {
      this.$refs["userCodeForm"].validate((valid) => {
        if (valid) {
          this.loginCode();
        } else {
          return false;
        }
      });
    },
    // 验证码登录调用接口
    async loginCode() {
      try {
        let res = await loginForCode({
          mobile: this.userCode.mobile,
          code: this.userCode.code,
        });
        if (res.data.code === 10000) {
          this.$message.success({
            message: "登录成功!",
            center: true,
            offset: 280,
          });

          let data = res.data.data;
          this.setInfo(data)
        } else {
          this.$message.error({
            message: res.data.message,
            center: true,
            offset: 280,
          });
        }
      } catch (error) {
        console.error("登录失败:", error);
      }
    },
    // 校验登录
    goLogin() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    clearList() {
      const allTabs = this.$store.getters["router/tabs"]
      const closeableTabs = allTabs.filter(
        (tab) => tab.path !== "/user/user-center"
      );
      if (closeableTabs.length !== 0) {
        closeableTabs.forEach((tab) => {
          this.$store.dispatch("router/closeTab", tab.path);
        });
      }
    },
    setInfo(data) {
      // 清空后台列表缓存
      this.clearList()
      // 存储token
      this.$utils.setCookie("token", data.token, 1);
      this.$store.commit("SET_TOKEN", data.token);
      // 更新登录状态
      this.$store.commit("SET_LOGIN", true);
      this.$store.commit("SET_IS_CHECK", data.user.is_check);
      this.$store.commit("SET_USERINFO", data.user);
      this.showUser = true;
      // 检查是否有重定向路径
      setTimeout(() => {
        const redirect = this.$route.query.redirect;
        if (redirect) {
          // 如果有重定向路径，跳转到指定页面
          this.safeNavigate(redirect, { replace: true });
        } else {
          // 否则跳转到首页
          this.safeNavigate("/", { replace: true });
        }
      }, 500);
    },
    // 登录调用接口
    async login() {
      try {
        let res = await login({
          mobile: this.user.name,
          password: this.user.passWord,
        });
        if (res.data.code === 10000) {
          this.$message.success({
            message: "登录成功!",
            center: true,
            offset: 280,
          });
          let data = res.data.data;
          // 设置信息
          this.setInfo(data)
        } else {
          this.$message.error({
            message: res.data.message,
            center: true,
            offset: 280,
          });
        }
      } catch (error) {
        console.error("登录失败:", error);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.qrcode-img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.margin-10 {
  margin-left: 10px;
}

.qrcode-container {
  padding-top: 20rpx;
  text-align: center;
}

.flex-inner-right {
  position: relative;
  margin-top: 30px;
  width: 380px;
  height: 385px;
  background: #ffffff;
  box-shadow: 0px 0px 11px 1px rgba(0, 11, 28, 0.13);
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;

  .flex-inner-right-img {
    position: absolute;
    margin-left: 334px;
    padding: 3px 3px 0 0;
    width: 44px;
    height: 44px;
  }

  .flex-inner-right-box {
    float: left;
    padding: 30px 13px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .flex-inner-right-box-title {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
      text-align: center;
    }

    .flex-inner-right-box-content {
      text-align: center;
      padding-top: 70px;

      .flex-inner-right-box-content-img {
        display: inline-block;
        width: 160px;
        height: 160px;
        background: #f5f5f5;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .login-text {
        padding-top: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #f5f5f5;

        .color-blue {
          cursor: pointer;
          color: #0c60e6;
        }
      }
    }

    .menu-box {
      padding-top: 20px;
      display: flex;
      align-content: center;
      border-bottom: 1px solid #e5e5e5;
      justify-content: space-around;
    }

    .menu-item {
      box-sizing: border-box;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #00112b;
      padding-bottom: 12px;
      border-bottom: 1px solid transparent;
    }

    .menu-item-active {
      box-sizing: border-box;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      padding-bottom: 12px;
      color: #00112b;
      border-bottom: 1px solid #246dff;
    }

    .input-box {
      padding: 14px 40px 0;

      .btn-code {
        width: 100px;
        height: 40px;
        background: #ebebeb;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #eef0f5;
        text-align: center;
        line-height: 40px;
        font-weight: 400;
        font-size: 14px;
        color: #00112b;
        cursor: pointer;
      }

      .input-icon {
        width: 13px;
        height: 13px;
        margin-right: 15px;
      }

      .input-item {
        margin-bottom: 30px;

        .input-error {
          line-height: 30px;
          font-weight: 400;
          font-size: 12px;
          color: #eb5637;
        }

        .input-item-box {
          height: 40px;
          line-height: 40px;
          background: #ffffff;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #eef0f5;
          padding: 0 13px;

          img {
            width: 13px;
            height: 13px;
            margin-right: 15px;
          }

          input {
            border: none;

            &:focus {
              outline: none;
              /* 移除默认的轮廓线 */
              box-shadow: none;
              /* 移除可能的阴影效果 */
              border: none;
              /* 确保没有边框 */
              -webkit-appearance: none;
              /* 移除iOS上的默认样式 */
              -moz-appearance: none;
              /* 移除Firefox上的默认样式 */
            }

            /* 移除自动填充时的背景色 */
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus {
              -webkit-box-shadow: 0 0 0 30px white inset !important;
            }
          }
        }
      }
    }

    .login-box {
      padding: 0 40px;

      .btn-size {
        width: 100%;
        height: 40px;
      }

      .login-box-text {
        font-weight: 400;
        font-size: 13px;
        color: #00112b;
        text-align: center;
        padding-top: 30px;
      }

      .color-blue {
        color: #0c60e6;
      }
    }
  }
}

.user-box {
  padding: 30px;

  .user-box-title {
    font-weight: 400;
    font-size: 18px;
    color: #474747;

    .color-blue {
      color: #0c60e6;
    }
  }

  .user-box-content {
    padding: 30px 20px;
    box-sizing: border-box;

    table {
      width: 100%;
      border-collapse: collapse;
      // border: 1px solid #e5e5e5;
      background: #d9e7fa;
      font-size: 18px;
      border-radius: 10px;

      td {
        width: 50%;
        height: 80px;
        text-align: center;
        position: relative;
      }

      .btn {
        font-size: 18px;
      }

      .color-orange {
        color: #ff9900;
      }
    }
  }

  .user-box-footer {
    text-align: center;

    .btn-color {
      width: 100%;
      background: #4B87FF;
    }
  }
}

.user-dashboard {
  padding: 30px;

  .welcome-section {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .user-avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .welcome-text {
        font-size: 18px;
        color: #00112b;
        font-weight: 600;

        .user-name {
          color: #0c60e6;
        }
      }

      .user-status {
        margin-top: 5px;
      }
    }
  }

  .stats-section {
    margin-bottom: 30px;

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 20px;
    }

    .stat-card {
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
      border: 1px solid #e9ecef;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
      }

      .stat-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        font-size: 24px;
        color: #1976d2;
        box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
      }

      .quote-icon {
        background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
        color: #d32f2f;
        box-shadow: 0 2px 8px rgba(211, 47, 47, 0.2);
      }

      .message-icon {
        background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
        color: #388e3c;
        box-shadow: 0 2px 8px rgba(56, 142, 60, 0.2);
      }

      .order-icon {
        background: linear-gradient(135deg, #fff3e0 0%, #ffcc02 100%);
        color: #f57c00;
        box-shadow: 0 2px 8px rgba(245, 124, 0, 0.2);
      }

      .product-icon {
        background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
        color: #1976d2;
        box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
      }

      .stat-content {
        flex-grow: 1;

        .stat-number {
          font-size: 24px;
          font-weight: bold;
          color: #00112b;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }

        .stat-subtitle {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }

  .quick-actions {
    margin-bottom: 10px;

    .section-title {
      font-size: 18px;
      font-weight: bold;
      color: #00112b;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e5e5e5;
    }

    .action-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 15px;
    }

    .action-card {
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 12px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
      border: 1px solid #e9ecef;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
        border-color: #0c60e6;
      }

      .action-icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background: linear-gradient(135deg, #0c60e6 0%, #4B87FF 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #ffffff;
        margin-bottom: 10px;
        box-shadow: 0 2px 8px rgba(12, 96, 230, 0.3);
      }

      .action-text {
        font-size: 14px;
        color: #00112b;
        font-weight: 500;
      }
    }
  }

  .dashboard-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    border-top: 1px solid #e5e5e5;

    .primary-btn {
      background: #4B87FF;
      color: white;
      padding: 10px 20px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      border: none;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background: #357abd;
      }

      .el-icon-user {
        margin-right: 8px;
      }
    }

    .logout-btn {
      color: #0c60e6;
      font-size: 16px;
      font-weight: bold;
      border: 1px solid #0c60e6;
      background: none;
      cursor: pointer;
      padding: 10px 20px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.3s ease;

      &:hover {
        background: #e6f7ff;
      }

      .el-icon-switch-button {
        margin-right: 8px;
      }
    }
  }
}
</style>
